import { render, staticRenderFns } from "./shipperForm.vue?vue&type=template&id=f5d6784c&scoped=true"
import script from "./shipperForm.vue?vue&type=script&lang=js"
export * from "./shipperForm.vue?vue&type=script&lang=js"
import style0 from "./shipperForm.vue?vue&type=style&index=0&id=f5d6784c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d6784c",
  null
  
)

export default component.exports